<template>
  <v-row class="mb-auto" justify="center">
    <v-col cols="12">
      <search v-if="issearch" :items="headers" @querydata="querydata"></search>
      <v-data-table show-select @toggle-select-all="selectAll" :multi-sort="false" v-model="selected" item-key="Id"
        :headers="headers" :items="mainData" :items-per-page="limit" :options.sync="options"
        :server-items-length="countData" :loading="loading" class="elevation-1 text-no-wrap" show-group-by
        :footer-props="{ itemsPerPageText: '分页:', 'items-per-page-options':[10,20,30,50,100,-1] }">
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>农事日志</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-btn :color="issearch ? 'error' : 'success'" dark small class="mr-2" @click="issearch = !issearch">
              <v-icon>{{ issearch ? "mdi-magnify-close" : "mdi-magnify" }}</v-icon>
            </v-btn>
            <v-btn small color="warning" dark @click="delselect">
              删除<v-icon>mdi-checkbox-marked-outline</v-icon>
            </v-btn>
            <v-dialog v-model="dialog" max-width="600px">
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-form ref="form">
                      <v-row>
                        <v-col cols="12" md="6">
                          <v-menu v-model="datepop1" :close-on-content-click="false" :nudge-right="40"
                            transition="scale-transition" offset-y min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field :rules="[(v) => !!v || '必填项']" v-model="editedItem.DateAt" label="日期"
                                prepend-icon="mdi-calendar" v-bind="attrs" v-on="on"></v-text-field>
                            </template>
                            <v-date-picker locale="zh-cn" v-model="editedItem.DateAt" @input="datepop1 = false">
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-text-field :rules="[(v) => !!v || '必填项']" v-model.trim="editedItem.Title" label="标题">
                          </v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-textarea rows="2" label="内容" v-model.trim="editedItem.Content"></v-textarea>
                        </v-col>
                        <v-col cols="12">
                          <v-card flat tile class="d-flex">
                            <v-img v-for="(item, index) in editedItem.ImgUrls" :key="index" max-width="72"
                              max-height="72" class="ml-1" :src="$store.state.serverhosts + item.url"
                              @click="viewImg(item.url)">
                              <v-icon color="error" @click.stop="delimg(item.url)">mdi-close-circle</v-icon>
                            </v-img>
                          </v-card>
                        </v-col>
                        <v-col cols="12">
                          <v-file-input accept="image/png, image/jpeg, image/gif" multiple chips :rules="filesize"
                            show-size counter label="农事图片" v-model="imgurls" :loading="loading" @change="upimg()">
                          </v-file-input>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">取消</v-btn>
                  <v-btn color="blue darken-1" :loading="loading" text @click="save">保存</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.ImgUrls="{ item }">
          <div class="d-flex">
            <v-img v-for="(img, index) in item.ImgUrls" :key="index" max-width="48" max-height="48" class="ml-1"
              :src="$store.state.serverhosts + img.url" @click="viewImg(img.url)"></v-img>
          </div>
        </template>
        <template v-slot:item.Title="{ item }">
          <v-tooltip bottom v-if="item.Title&&item.Title.length > 17">
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on" style="max-width: 240px;"
                class="d-inline-block text-truncate">{{ item.Title }}</span>
            </template>
            <span>{{ item.Title }}</span>
          </v-tooltip>
          <span v-else>{{ item.Title }}</span>
        </template>
        <template v-slot:item.Content="{ item }">
          <v-tooltip bottom v-if="item.Content&&item.Content.length > 17">
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on" style="max-width: 240px;"
                class="d-inline-block text-truncate">{{ item.Content }}</span>
            </template>
            <span>{{ item.Content }}</span>
          </v-tooltip>
          <span v-else>{{ item.Content }}</span>
        </template>
        <template v-solt:footer.page-text="{ item }">
          <v-btn color="success">text</v-btn>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon class="mr-4" color="info" @click="editItem(item)">mdi-pencil</v-icon>
          <v-icon color="error" @click="deleteItem(item)">mdi-delete</v-icon>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">刷新数据</v-btn>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
  import search from "@/components/search";
  export default {
    components: {
      search,
    },
    data: function () {
      return {
        dialog: false,
        selected: [],
        headers: [{
          text: "产品",
          value: "PiCier.Producter.Name",
          groupable: false,
        },
        {
          text: "用户",
          value: "PiCier.Userer.Name",
        },
        {
          text: "批次",
          value: "PiCier.PiCi",
        },
        {
          text: "标题",
          value: "Title",
          groupable: false,
        },
        {
          text: "内容",
          value: "Content",
          groupable: false,
        },
        {
          text: "操作日期",
          value: "DateAt",
          groupable: false,
        },
        {
          text: "图片",
          value: "ImgUrls",
          groupable: false,
        },
        { text: "创建时间", value: "CreateAt", groupable: false },
        { text: "更新时间", value: "UpdateAt", groupable: false },
        {
          text: "操作",
          value: "actions",
          sortable: false,
          groupable: false,
          width: 105,
        },
        ],
        issearch: false,
        mainData: [],
        countData: 0,
        offset: 0,
        limit: this.$store.state.glimit,
        query: "",
        exclude: "",
        sortby: "",
        order: "",
        options: {},
        loading: false,
        editedIndex: -1,
        editedItem: {
          PiCier: {
            Id: 0,
          },
          DateAt: this.$utils.formatDate(new Date(), "yyyy-MM-dd"),
          ImgUrls: [],
        },
        defaultItem: {
          PiCier: {
            Id: 0,
          },
          DateAt: this.$utils.formatDate(new Date(), "yyyy-MM-dd"),
          ImgUrls: [],
        },
        datepop1: false,
        filesize: [
          (v) => {
            for (let index = 0; index < v.length; index++) {
              if (v[index].size > 2000000) return "单个文件不能大于2MB!";
            }
            return true;
          },
        ],
        imgurls: [],
      };
    },
    computed: {
      formTitle() {
        return this.editedIndex === -1 ? "新增" : "编辑";
      },
    },
    watch: {
      dialog(val) {
        val || this.close();
      },
      options: {
        handler() {
          //立即执行
          this.limit = this.options.itemsPerPage;
          this.offset = (this.options.page - 1) * this.limit;
          this.sortby = "";
          this.order = "";
          for (let index = 0; index < this.options.sortBy.length; index++) {
            this.sortby += this.options.sortBy[index] + ",";
            this.order += this.options.sortDesc[index] ? "desc," : "asc,";
          }
          if (this.sortby.length > 0) {
            this.sortby = this.sortby.slice(0, -1);
            this.order = this.order.slice(0, -1);
          }
          this.initialize();
        },
        deep: true, //对象深度监听
      },
    },
    methods: {
      delimg(url) {
        let imgs = [];
        if (this.editedIndex > -1) {
          imgs = this.mainData[this.editedIndex].ImgUrls;
        } else {
          imgs = this.editedItem.ImgUrls;
        }
        for (let index = 0; index < imgs.length; index++) {
          if (imgs[index].url === url) {
            imgs.splice(index, 1);
            this.$api.delFile({
              file: url,
            }).catch((error) => {
              this.$store.commit("setsnack", { message: "服务端文件删除失败" + url });
              console.error(error);
            });
          }
        }
      },
      upimg() {
        let imgslen = this.imgurls.length;
        let imgupnum = 0;
        if (imgslen > 0) this.loading = true;
        for (let index = 0; index < imgslen; index++) {
          this.$store.commit("setsnack", { message: "第[" + (index + 1) + "]图片上传中", color: "info" });
          let file = new FormData();
          file.append("file", this.imgurls[index]);
          this.$api.upImg(file).then((res) => {
            imgupnum++;
            if (imgupnum >= imgslen) this.loading = false;
            if (this.editedIndex > -1) {
              this.mainData[this.editedIndex].ImgUrls.push({
                url: res.data.imgUrl,
              });
            } else {
              this.editedItem.ImgUrls.push({
                url: res.data.imgUrl,
              });
            }
            this.$store.commit("setsnack", { message: "第[" + (index + 1) + "]图片上传成功", color: "success" });
          }).catch((error) => {
            imgupnum++;
            if (imgupnum >= imgslen) this.loading = false;
            console.error(error);
            this.$store.commit("setsnack", { message: "第[" + (index + 1) + "]图片上传失败" });
          });
        }
      },
      viewImg(src) {
        this.$store.commit("setviewimg", this.$store.state.serverhosts + src);
      },
      querydata(query, exclude) {
        this.query = query;
        this.exclude = exclude;
        this.initialize();
      },
      selectAll(item) {
        this.selected = item.value ? item.items : [];
      },
      delselect(e) {
        if (!confirm("确认删除所有选中项吗?")) return;
        if (this.selected.length > 0) {
          let ids = "";
          let arrid = [];
          for (let index = 0; index < this.selected.length; index++) {
            ids += this.selected[index].Id + ",";
            arrid.push(this.selected[index].Id);
          }
          if (ids.length > 0) {
            ids = ids.slice(0, -1);
          }
          this.loading = true
          this.$api.delJiLu({
            id: ids,
          }).then((res) => {
            this.loading = false
            for (let index = 0; index < arrid.length; index++) {
              this.mainData = this.mainData.filter(
                (item) => item.Id != arrid[index]
              );
            }
            this.countData -= arrid.length;
          }).catch((error) => {
            this.loading = false
            let message = (error && error.msg) || "删除选中选失败！";
            this.$store.commit("setsnack", { message });
            console.error(error);
          });
        } else {
          this.$store.commit("setsnack", { message: "尚未选择任何项目", color: "warning" });
        }
      },
      initialize() {
        let data = {
          limit: this.limit,
          offset: this.offset,
        };
        if (this.query != "") {
          data.query = this.query;
        }
        if (this.exclude != "") {
          data.exclude = this.exclude;
        }
        if (this.sortby != "") {
          data.sortby = this.sortby;
          data.order = this.order;
        }
        this.loading = true;
        this.$api.getJiLus(data).then((res) => {
          this.loading = false;
          if (res.data) {
            for (let index = 0; index < res.data.length; index++) {
              res.data[index].ImgUrls = JSON.parse(res.data[index].ImgUrls);
            }
            this.mainData = res.data;
            this.countData = res.count;
          } else {
            this.mainData = [];
            this.countData = 0;
          }
        }).catch((error) => {
          this.loading = false;
          let message = (error && error.msg) || "获取数据列表失败！";
          this.$store.commit("setsnack", { message });
          console.error(error);
        });
      },
      editItem(item) {
        this.editedIndex = this.mainData.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      },
      deleteItem(item) {
        const index = this.mainData.indexOf(item);
        if (confirm("确认删除此项数据吗?")) {
          const data = {
            id: item.Id,
          };
          this.loading = true
          this.$api.delJiLu(data).then((res) => {
            this.loading = false
            this.mainData.splice(index, 1);
            this.countData--;
          }).catch((error) => {
            this.loading = false
            let message = (error && error.msg) || "删除失败！";
            this.$store.commit("setsnack", { message });
            console.error(error);
          });
        }
      },
      close() {
        this.dialog = false
        this.imgurls = []
        this.$nextTick(() => {
          this.editedItem = JSON.parse(JSON.stringify(this.defaultItem));
          this.editedIndex = -1;
        });
      },
      save() {
        if (!this.$refs.form.validate()) return;
        let data = JSON.parse(JSON.stringify(this.editedItem));
        data.ImgUrls = JSON.stringify(data.ImgUrls);

        delete data.PiCier.PiCi;
        delete data.PiCier.Producter;
        delete data.PiCier.Userer;

        delete data.CreateAt;
        delete data.UpdateAt;
        this.editedItem.UpdateAt = this.$utils.formatDate(
          new Date(),
          "yyyy-MM-dd hh:mm:ss"
        );
        this.loading = true;
        if (this.editedIndex > -1) {
          this.$api.editJiLu(data).then((res) => {
            this.loading = false;
            Object.assign(this.mainData[this.editedIndex], this.editedItem);
            this.close();
          }).catch((error) => {
            this.loading = false;
            let message = (error && error.msg) || "编辑失败！";
            this.$store.commit("setsnack", { message });
            console.error(error);
          });
        }
      },
    },
  };
</script>